import { render, staticRenderFns } from "./DispatchSummaryAssetTypes.vue?vue&type=template&id=dbd5083e&scoped=true"
import script from "./DispatchSummaryAssetTypes.vue?vue&type=script&lang=js"
export * from "./DispatchSummaryAssetTypes.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummaryAssetTypes.vue?vue&type=style&index=0&id=dbd5083e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd5083e",
  null
  
)

export default component.exports